<template>
  <base-table
    ref="table"
    url="/catalogClass/get"
    :toolbar="toolbar"
    :columns="columns"
  ></base-table>
</template>
<script>
export default {
  name: 'test',
  data() {
    return {
      toolbar: {
        formItems: [
          {
            label: 'ProductId',
            prop: 'pid',
            cp: this.$ComparePatterns.Matchs,
          },
        ],
        query: {
          SortFields: JSON.stringify([{ Field: 'time', Order: -1 }]),
        },
      },
      columns: [
        { bind: { label: 'ProductId', prop: 'pid' } },
        { bind: { label: '时间', prop: 'time' } },
        { bind: { label: '备注', prop: 'remark' } },
        {
          bind: { label: '操作', prop: 'Name', width: 100 },
          header: {
            component: 'cell-button',
            bind: { label: '新建', icon: 'el-icon-plus', type: 'primary' },
            on: { click: this.beginAdd },
          },
          default: {
            component: 'cell-buttons',
            bind: {
              buttons: [{ label: '删除', type: 'text', click: this.delData }],
            },
          },
        },
      ],
    }
  },
}
</script>